import { GoabFormItem, GoabCheckbox } from "@abgov/react-components";
import { ErrorMessage } from "./ErrorMessage";
import GoogleGoabInput from "../../AddressComplete/GoogleGoabInput";

export const AddressSearch = ({ form, getResourceValue, handlePopulate, disabled, handleChange }) => (
    <>
        <p className="secondary">{getResourceValue({ key: "RESOURCES@step.label" })} 1</p>
        <GoabFormItem label={getResourceValue({ key: "RESOURCES@form.searchPrimaryResidence.label" })} helpText={<>{getResourceValue({ key: "RESOURCES@form.findAddress.helpText" })}</>}>
            <GoogleGoabInput
                width="100%"
                onPopulate={handlePopulate}
                disabled={disabled}
                getResourceValue={getResourceValue}
                form={form}
            />
            <ErrorMessage error={form.errors.enterAlbertaAddress} getResourceValue={getResourceValue} />
        </GoabFormItem>
        <GoabFormItem
            error={form.errors.addressNotFound && getResourceValue({ key: "RESOURCES@form.addressNotFound.label" })}
            id="addressNotFound"
        >
            <GoabCheckbox
                name="addressNotFound"
                value={form.values.addressNotFound}
                checked={form.values.addressNotFound}
                text={getResourceValue({ key: "RESOURCES@form.addressNotFound.label" })}
                mt="m"
                mb="l"
                error={form.errors.addressNotFound}
                onChange={({name, value, checked}) => handleChange(form, name, checked)}
            />
        </GoabFormItem>
    </>
);